import { css } from "@emotion/react";

import { Icon } from "@zapier/zinnia-icons";

type ClearSelectionButtonProps = {
  clearSelection: () => void;
  isFocused: boolean;
  isHovered: boolean;
};

const clearSelectionButton = css`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  background: transparent;
`;

/**
 * The icon which sits inside the input field.
 */
const ClearSelectionButton = ({
  clearSelection,
  isFocused,
  isHovered,
}: ClearSelectionButtonProps) => {
  // If not focused or hovered it should be a specific color,
  // otherwise it should inherit its color.
  const iconColor = !(isFocused || isHovered) ? "GrayWarm7" : undefined;
  return (
    <button
      css={clearSelectionButton}
      onClick={clearSelection}
      title="Clear Selection"
    >
      <Icon
        canAcceptPointerEvents={false}
        color={iconColor}
        name="formXCircle"
        size={20}
      />
    </button>
  );
};

export default ClearSelectionButton;
